import { Route, Routes } from 'react-router-dom';

import Dashboard from '../pages/dashboard';
import Index from '../pages';

export function HomeRoute() {
  return (
    <Routes>
      <Route path='/' element={<Index child={<Dashboard />}/>} />
    </Routes>
  );
}
